import * as React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import * as actions from "../../store/cases/actions";
import { Case, User, Category, Tag } from "../../api/classes";
import CaseListItem from "../../pages/cases/caseListItem";
import { List, TextField, IconButton, Typography } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CategorySelect from "../categorySelect";
import FolderSelect from "../folderSelect";
import * as constants from "../../api/constants";
import FilterView from "../filter";
import { DubitoSvc } from "src/api";
import UserSelect from "../userSelect";

import DateTimePicker from "material-ui-pickers/DateTimePicker";
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";

import * as moment from "moment";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import CaseSelect from "../caseSelect";
import SourceSelect from "../sourceSelect";
import FileUpload from "../fileUpload";
interface Props {
  open: boolean;
  cases: Case[];
  onClose: () => void;
  onCreate: (case_id: number) => void;
  users: User[];
  categories: Category[];
  tags: Tag[];
  fetchCases: () => void;
  fetchUsers: () => void;
  fetchCategories: () => void;
  fetchTags: () => void;
}

class CreateReportDialog extends React.Component<Props> {
  state = {
    open: this.props.open,
    scroll: "paper",
    text: "",
    category: -1,
    folder: constants.FOLDER_NEWS_FEED,
    tags: [],
    creating: false,
    assignedUser: undefined,
    error: "",
    date: moment().toISOString(),
    caseID: undefined,
    source: constants.SOURCE_WHATSAPP,
    accountName: "",
    phone: "",
    files: []
  };
  componentWillReceiveProps(next: Props) {
    if (!this.props.open && next.open) {
      this.setState({ open: next.open });
    }
    if (this.props.open && !next.open) {
      this.setState({ open: next.open });
    }
  }
  componentWillMount() {
    if (!this.props.cases) {
      this.props.fetchCases();
    }
    if (!this.props.users) {
      this.props.fetchUsers();
    }
    if (!this.props.categories) {
      this.props.fetchCategories();
    }
    if (!this.props.tags) {
      this.props.fetchTags();
    }
  }

  handleCreate = () => {
    if (this.state.text.length === 0) {
      this.setState({ error: "Report Text is required" });
      return;
    }
    if (!this.state.caseID) {
      this.setState({ error: "Please select a case" });

      return;
    }
    let file_ids = undefined;
    if (this.state.files) {
      file_ids = this.state.files.map(f => f.id);
    }
    DubitoSvc.createReport({
      text: this.state.text,
      case_id: this.state.caseID,
      source: this.state.source,
      account_name: this.state.accountName,
      phone: this.state.phone,
      file_ids,
      created_at: moment(this.state.date)
        .utc()
        .format("YYYY-MM-DD HH:MM:ss")
    }).then(res => {
      this.setState({ creating: false });
      this.props.fetchCases();
      this.props.onCreate(res.id);
    });
  };
  handleClose = () => {
    if (this.state.creating) {
      return;
    }
    this.setState({ open: false, query: "" });
    this.props.onClose();
  };

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          scroll={"paper"}
          aria-labelledby="scroll-dialog-title"
          maxWidth="sm"
          fullWidth
          PaperProps={{
            style: { height: "100%" }
          }}
          style={{ height: "100%" }}
        >
          <DialogTitle id="scroll-dialog-title">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ flex: 1 }}>Create a report</span>
            </div>
          </DialogTitle>
          <DialogContent>
            {this.state.error.length > 0 && (
              <div style={{ color: "red", marginBottom: 16 }}>
                {this.state.error}
              </div>
            )}
            <TextField
              label="Report Text"
              autoFocus
              multiline
              onChange={e => this.setState({ text: e.target.value })}
              style={{ width: "100%", marginBottom: 16 }}
              fullWidth
            />
            <TextField
              label="Name"
              autoFocus
              onChange={e => this.setState({ accountName: e.target.value })}
              style={{ width: "100%", marginBottom: 16 }}
              fullWidth
            />
            <TextField
              label="Phone"
              autoFocus
              onChange={e => this.setState({ phone: e.target.value })}
              style={{ width: "100%", marginBottom: 16 }}
              fullWidth
            />
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end"
                }}
              >
                <DateTimePicker
                  autoOk
                  ampm={false}
                  clearable
                  fullWidth
                  label="Date"
                  style={{
                    textAlign: "center"
                  }}
                  format="D MMMM YYYY HH:mm"
                  value={this.state.date}
                  onChange={m => {
                    this.setState({ date: m ? m.toISOString() : null });
                  }}
                />
              </div>
            </MuiPickersUtilsProvider>
            <Typography variant="caption" style={{ marginTop: 24 }}>
              Source
            </Typography>
            <SourceSelect
              value={this.state.source}
              onSelect={s => this.setState({ source: s })}
            />
            <Typography
              variant="caption"
              style={{ marginTop: 8, marginBottom: 4 }}
            >
              Case
            </Typography>
            <CaseSelect
              caseID={this.state.caseID}
              onSelect={caseID => {
                //console.log(caseID);
                this.setState({ caseID: caseID, showCasePicker: false });
              }}
              onClose={() => this.setState({ showCasePicker: false })}
            />
            <Typography
              variant="caption"
              style={{ marginTop: 8, marginBottom: 4 }}
            >
              Files
            </Typography>
            {this.state.files.length > 0 && (
              <div style={{ paddingTop: 12, paddingBottom: 12 }}>
                {this.state.files.map(file => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 8
                      }}
                    >
                      <a
                        target="_blank"
                        href={
                          "https://dubito.s3.eu-central-1.amazonaws.com/" +
                          file.file_url
                        }
                      >
                        {file.file_url.lastIndexOf("/") > -1
                          ? file.file_url.substring(
                              file.file_url.lastIndexOf("/") + 1
                            )
                          : file.file_url}
                      </a>
                    </div>
                  );
                })}
              </div>
            )}
            <FileUpload
              onUploaded={file => {
                const list = this.state.files;
                list.push(file);
                this.setState({ files: list, showAttach: false });
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              disabled={this.state.creating}
              onClick={this.handleClose}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              disabled={this.state.creating}
              onClick={this.handleCreate}
              color="primary"
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: Props) => ({
    cases: state.cases.list,
    users: state.cases.users,
    categories: state.cases.categories,
    tags: state.cases.tags
  }),
  dispatch => ({
    fetchCases: (): any => dispatch(actions.fetchCases()),
    fetchUsers: (): any => dispatch(actions.fetchUsers()),
    fetchCategories: (): any => dispatch(actions.fetchCategories()),
    fetchTags: (): any => dispatch(actions.fetchTags())
  })
)(CreateReportDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/createReport.tsx